'use client'

import { Badge } from '@/components/ui/badge'

import { FadeUp } from '@/components/ui/fade-up'
export function PrivacyContent() {
  return (
    <>
      {/* ヒーローセクション */}
      <section className="relative bg-[#BEB0A8] py-12 md:py-16">
        <div
          className="animate-fade-up container"
        >
          <div className="max-w-3xl mx-auto text-center">
            <Badge className="mb-4 font-['Noto_Sans_JP',_sans-serif] bg-[#292623] text-white">個人情報保護方針</Badge>
            <h1 className="font-['Montserrat',_sans-serif] text-[32px] md:text-[46px] font-semibold text-[#292623] tracking-[-0.92px] mb-6">
              プライバシーポリシー
            </h1>
          </div>
        </div>
      </section>

      {/* 本文 */}
      <section className="py-16">
        <div className="container px-4">
          <FadeUp
            className="max-w-4xl mx-auto"
          >
            <div className="space-y-8 text-[#292623]">
            <p className="text-lg leading-relaxed">
              株式会社CodeFox（以下「当社」といいます。）は、個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）を遵守すると共に、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定め、適切な取扱い及び保護に努めます。
            </p>

            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-bold mb-4">1. 個人情報の定義</h2>
                <p className="leading-relaxed">
              個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。）を意味するものとします。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">2. 個人情報の利用目的</h2>
                <p className="leading-relaxed">当社は、個人情報を以下の目的で利用します。</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
              <li>当社サービスの提供、管理及び運営のため</li>
              <li>お客様が当社のサービスを利用するにあたり、当社が必要な連絡をするため</li>
              <li>当社のサービスに関するご案内、お問い合わせへの対応のため</li>
              <li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
              <li>当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為への対応のため</li>
              <li>当社への応募に対し、当社が必要な連絡をするため</li>
              <li>その他、上記の利用目的に付随する目的</li>
            </ul>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">3. 利用目的の変更</h2>
                <p className="leading-relaxed">
              当社は、個人情報の利用目的を相当の関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合にはお客様に通知又は公表します。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">4. 個人情報利用の制限</h2>
                <p className="leading-relaxed">
              当社は、個人情報保護法その他の法令により許容される場合を除き、お客様の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し、次の場合はこの限りではありません。
            </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
              <li>法令に基づく場合</li>
              <li>人の生命、身体又は財産の保護のために必要がある場合であって、お客様の同意を得ることが困難であるとき</li>
              <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難であるとき</li>
              <li>国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
            </ul>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">5. 個人情報の適正な取得</h2>
                <p className="leading-relaxed">
              当社は、適正に個人情報を取得し、不正の手段により取得しません。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">6. 個人情報の安全管理</h2>
                <p className="leading-relaxed">
              当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。また、当社は、個人情報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">7. 個人情報の第三者提供</h2>
                <p className="leading-relaxed">
              当社は、個人情報保護法その他の法令に基づき開示が認められる場合を除くほか、あらかじめお客様の同意を得ないで、個人情報を第三者に提供しません。但し、次に掲げる場合は上記に定める第三者への提供には該当しません。
            </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
              <li>当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合</li>
              <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
              <li>個人情報保護法の定めに基づき共同利用する場合</li>
            </ul>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">8. 個人情報の開示</h2>
                <p className="leading-relaxed">
              当社は、本人から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり1,000円）を頂戴しておりますので、あらかじめ御了承ください。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">9. 個人情報の訂正および削除</h2>
                <p className="leading-relaxed">
              当社は、お客様から、個人情報が真実でないという理由によって、個人情報保護法の定めに基づきその内容の訂正、追加又は削除（以下「訂正等」といいます。）を求められた場合には、お客様ご本人からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨をお客様に通知します（訂正等を行わない旨の決定をしたときは、お客様に対しその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が訂正等の義務を負わない場合は、この限りではありません。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">10. 個人情報の利用停止等</h2>
                <p className="leading-relaxed">
              当社は、お客様から、本人の個人情報が、あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により取得されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止又は消去（以下「利用停止等」といいます。）を求められた場合、又は個人情報がご本人の同意なく第三者に提供されているという理由により、個人情報保護法の定めに基づきその提供の停止（以下「提供停止」といいます。）を求められた場合において、そのご請求に理由があることが判明した場合には、お客様ご本人からのご請求であることを確認の上で、遅滞なく個人情報の利用停止等又は提供停止を行い、その旨をお客様に通知します。但し、個人情報保護法その他の法令により、当社が利用停止等又は提供停止の義務を負わない場合は、この限りではありません。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">11. Cookie（クッキー）その他の技術の利用</h2>
                <p className="leading-relaxed">
              当社のサービスは、Cookie及びこれに類する技術を利用することがあります。これらの技術は、当社による当社のサービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookieを無効化されたいユーザーは、ウェブブラウザの設定を変更することによりCookieを無効化することができます。但し、Cookieを無効化すると、当社のサービスの一部の機能をご利用いただけなくなる場合があります。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">12. プライバシーポリシーの変更</h2>
                <p className="leading-relaxed">
              プライバシーポリシーの内容は、法令その他、本プライバシーポリシーに別段の定めのある事項を除いて、お客様に通知することなく、変更することができるものとします。<br />
              当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">お問い合わせ</h2>
                <p className="leading-relaxed">
              開示等のお申出、ご意見、ご質問、苦情のお申出その他個人情報の取扱いに関するお問い合わせは、下記の窓口までお願い致します。
            </p>
                <p className="leading-relaxed">
              株式会社CodeFox お問い合わせ係<br />
              <a href="mailto:info@codefox.co.jp">info@codefox.co.jp</a>
            </p>

              </div>
              <div>
                <h2 className="text-2xl font-bold mb-4">附則</h2>
                <p className="leading-relaxed">このプライバシーポリシーは、2022/08/12から施行します。</p>
              </div>
            </div>
            </div>
          </FadeUp>
        </div>
      </section>
    </>
  )
}
